<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import UiButton from '@/components/shared/UiButton.vue'

import { useAppMode } from '@/composables/useAppMode'
import { copyToClipboard } from '@/helpers/copyToClipboard'

const props = defineProps<{
  link: string
}>()

const { mode } = useAppMode()
const { t } = useI18n()

const input = ref<HTMLInputElement | null>(null)
const buttonText = ref(t('Compete.button.Copy'))

const copyLink = () => {
  copyToClipboard(props.link)
  buttonText.value = t('Compete.button.Copied')
  setTimeout(() => {
    buttonText.value = t('Compete.button.Copy')
  }, 5000)
}
</script>

<template>
  <div class="invite-friends" v-if="link">
    <div :class="`invite-friends__intro--${mode}`">
      {{ $t('Compete.message.CopyLink') }}
    </div>
    <div class="invite-friends__input-row" :class="`invite-friends__input-row--${mode}`">
      <input ref="input" :value="link" disabled :class="`invite-friends__input--${mode}`" />
      <ui-button @click="copyLink" :class="`invite-friends__button--${mode}`">{{
        buttonText
      }}</ui-button>
    </div>
  </div>
</template>

<style lang="scss">
.invite-friends {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  gap: calc(1 * var(--th));
  font-size: calc(1.5 * var(--th));
  color: #fff;

  &__intro {
    &--desktop {
      text-align: center;
    }

    &--mobile {
      font-size: calc(1.7 * var(--tgh));
      font-weight: 500;
      text-align: center;
      padding: 0 10%;
    }
  }

  &__input {
    &--desktop {
      color: rgba(255, 255, 255, 0.6);
      font-size: calc(2 * var(--th));
      font-weight: 400;
      flex: 1;
      background: transparent;
      outline: none;
      border: none;
      padding: var(--tgh) 0 var(--tgh) calc(2 * var(--tgh));
    }

    &--mobile {
      color: rgba(255, 255, 255, 0.6);
      font-size: calc(1.7 * var(--tgh));
      font-weight: 400;
      background: transparent;
      outline: none;
      border: none;
      padding: var(--tgh) 0 var(--tgh) calc(2 * var(--tgh));
      min-width: 0;
    }
  }

  &__input-row {
    display: flex;
    height: calc(5 * var(--th));
    padding: 0 0.25vw;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.2);
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
    justify-content: space-between;

    &--mobile {
      height: calc(4 * var(--th));
    }
  }

  &__button {
    &--desktop {
      font-size: calc(1.3 * var(--th));
      height: 50%;
      padding: 0 calc(0.7 * var(--tw));
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &--mobile {
      font-size: calc(1.3 * var(--th));
      height: 50%;
      padding: calc(1.5 * var(--tgh)) var(--tgh);
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: var(--tgh);
    }
  }
}
</style>
